/**
* Navigation Block
*
* All functionality related to the Navigation block.
*/

import { trackNavClick } from '../analytics';

let Navigation = (function($) {

  // Selectors
  let _s = {
    container: '.wp-block-indp-navigation',
    mobileToggle: '.js-mobile-toggle',
    subMenuToggle: '.js-sub-menu-toggle',
    menuItem: '.menu-item',
    desktopBreakpoint: 960,
    navLink: '#site-navigation .menu-item a'
  };

  // Initialize
  let _init = function() {
    _bindEvents();
    _handleResize();
    _initStickyNav();
  };

  // Bind Events
  let _bindEvents = function() {
    // Mobile menu toggle
    $(document).on('click', _s.mobileToggle, function(e) {
      e.preventDefault();
      _toggleMobileMenu();
    });

    // Submenu toggle (mobile only)
    $(document).on('click', _s.subMenuToggle, function(e) {
      e.preventDefault();
      _toggleSubMenu($(this));
    });

    // Close mobile menu on escape key
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $(_s.container).hasClass('has-mobile-active')) {
        _toggleMobileMenu();
      }
    });

    // Close mobile menu when clicking outside
    $(document).on('click', function(e) {
      if ($(_s.container).hasClass('has-mobile-active') && 
          !$(e.target).closest(_s.container).length) {
        _toggleMobileMenu();
      }
    });

    // Close mobile menu on resize to desktop
    $(window).on('resize', _handleResize);

    // Close mobile menu when clicking anchor links
    $(document).on('click', _s.container + ' a[href^="#"]', function() {
      if ($(_s.container).hasClass('has-mobile-active')) {
        _toggleMobileMenu();
      }
    });

    // Desktop mega menu hover (only on desktop)
    $(document).on('mouseenter', '.menu-item-has-children', function() {
      if ($(window).width() >= _s.desktopBreakpoint) {
        $(_s.container).addClass('has-mega-active');
      }
    });

    // Close mega menu only when leaving the entire nav container
    $(document).on('mouseleave', _s.container, function() {
      if ($(window).width() >= _s.desktopBreakpoint) {
        $(_s.container).removeClass('has-mega-active');
      }
    });

    // Track navigation link clicks
    $(document).on('click', _s.navLink, function() {
      const linkText = $(this).text().trim();
      const linkUrl = $(this).attr('href');
      trackNavClick(linkText, linkUrl);
    });
  };

  // Toggle mobile menu
  let _toggleMobileMenu = function() {
    const $nav = $(_s.container);
    const $toggle = $(_s.mobileToggle);
    const isActive = $nav.hasClass('has-mobile-active');

    $nav.toggleClass('has-mobile-active');
    $toggle.attr('aria-expanded', !isActive);

    // Prevent body scroll when menu is open
    if (!isActive) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', '');
    }
  };

  // Toggle submenu (mobile)
  let _toggleSubMenu = function($toggle) {
    const $menuItem = $toggle.closest(_s.menuItem);
    const isActive = $menuItem.hasClass('has-sub-menu-active');

    // Close other open submenus
    $(_s.menuItem).not($menuItem).removeClass('has-sub-menu-active');

    // Toggle current submenu
    $menuItem.toggleClass('has-sub-menu-active');
    $toggle.attr('aria-expanded', !isActive);
  };

  // Handle resize - close mobile menu on desktop
  let _handleResize = function() {
    const windowWidth = $(window).width();
    const $nav = $(_s.container);
    
    // If desktop view and mobile menu is active, close it
    if (windowWidth >= _s.desktopBreakpoint && $nav.hasClass('has-mobile-active')) {
      $nav.removeClass('has-mobile-active');
      $(_s.mobileToggle).attr('aria-expanded', false);
      $('body').css('overflow', '');
    }

    // Remove mega menu class on mobile
    if (windowWidth < _s.desktopBreakpoint) {
      $nav.removeClass('has-mega-active');
    }
  };

  // Initialize sticky navigation
  let _initStickyNav = function() {
    const $nav = $(_s.container);
    if (!$nav.length) return;

    const navHeight = $nav.outerHeight();
    const navOffset = $nav.offset().top;
    let isSticky = false;

    $(window).on('scroll', function() {
      const scrollTop = $(window).scrollTop();

      if (scrollTop > navOffset && !isSticky) {
        // Add placeholder to prevent content jump
        $nav.before('<div class="nav-placeholder" style="height:' + navHeight + 'px"></div>');
        $nav.css({
          'position': 'fixed',
          'top': '0',
          'left': '0',
          'right': '0',
          'width': '100%'
        });
        $nav.addClass('is-sticky');
        isSticky = true;
      } else if (scrollTop <= navOffset && isSticky) {
        $('.nav-placeholder').remove();
        $nav.css({
          'position': '',
          'top': '',
          'left': '',
          'right': '',
          'width': ''
        });
        $nav.removeClass('is-sticky');
        isSticky = false;
      }
    });
  };

  // Public API
  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

// Export Module so it can be imported in index.js
export default Navigation;